import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { fetchUserProfile, getIsLoadedUserProfileData, getUserProfileData } from '@entities/User';
import { userProfileType } from '@entities/User/module/types/UserSchema';
import { getAuthUserData } from '@entities/Auth';

export const useProfile = (): {
  userProfile: userProfileType;
  isLoaded: boolean;
} => {
  const dispatch = useAppDispatch();
  const userProfile = useAppSelector(getUserProfileData);
  const isLoaded = useAppSelector(getIsLoadedUserProfileData);
  const auth = useAppSelector(getAuthUserData);

  useEffect(() => {
    if (!isLoaded && auth.isLoggedin) {
      dispatch(fetchUserProfile());
    }
  }, []);

  return { userProfile, isLoaded };
};
